import PropTypes from 'prop-types';
import './AuthLayout.css';

const ToothMark = ({size, title}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden={title ? undefined : 'true'}
    role={title ? 'img' : undefined}
    focusable="false"
  >
    {title && <title>{title}</title>}
    <path
      d="M16 4c-4.5 0-8.5 1.6-8.5 5.5 0 3 1 6 1.8 9 .5 1.9 1.2 5 1.6 7.5.3 2 1.1 3 2.4 3 1.4 0 1.8-1.4 2-3.6.2-2.2.3-3.4.7-3.4.4 0 .5 1.2.7 3.4.2 2.2.6 3.6 2 3.6 1.3 0 2.1-1 2.4-3 .4-2.5 1.1-5.6 1.6-7.5.8-3 1.8-6 1.8-9C24.5 5.6 20.5 4 16 4z"
      fill="#C43B71"
    />
    <circle cx="22" cy="9" r="3.5" fill="#fff" stroke="#C43B71" strokeWidth="1.5" />
    <text
      x="22"
      y="11"
      textAnchor="middle"
      fontSize="3.5"
      fontWeight="800"
      fill="#C43B71"
      fontFamily="Manrope, system-ui"
    >
      AI
    </text>
  </svg>
);

ToothMark.propTypes = {size: PropTypes.number.isRequired, title: PropTypes.string};

const SealIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path
      d="M12 1.5l2.6 2 3.2-.3 1.2 3 2.7 1.8-.7 3.2 1.5 2.9-2.2 2.4.2 3.2-3.1 1-1.6 2.8-3.1-.6-2.7 1.7-2-2.5-3-1.3-.3-3.2L1 14l1.7-2.7-1-3.1 2.4-2.2 1-3 3.2-.2L11 1l1 .5z"
      fill="#C43B71"
    />
    <path d="M8 12l3 3 5-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * Two-column sign-in / sign-up shell from the legacy app: brand panel on desktop (>= 1024 px),
 * single column with a small wordmark on mobile. The HIPAA badge sits under the form card.
 */
export default function AuthLayout({children}) {
  return (
    <main className="auth-shell">
      <aside className="auth-brand" aria-label="About AIDentalBook">
        <div className="auth-brand-watermark" aria-hidden="true">
          <ToothMark size={420} />
        </div>
        <div className="auth-brand-top">
          <img src="/assets/logo-round.png" alt="AIDentalBook logo" width="72" height="72" />
          <p className="auth-brand-title">Your dental passport, everywhere you go.</p>
          <p className="auth-brand-copy">
            Records, X-rays, appointments, and AI diagnostics — held in one place, and always yours.
          </p>
        </div>
        <div className="auth-brand-bottom">
          <ul className="auth-pills">
            <li className="auth-pill">
              <SealIcon />
              Private Cloud
            </li>
            <li className="auth-pill">
              <SealIcon />
              Your Data Stays Yours
            </li>
          </ul>
          <p className="auth-powered">Powered by Agape MedTecs Inc.</p>
        </div>
      </aside>

      <div className="auth-main">
        <div className="auth-col">
          <div className="auth-logo-sm">
            <ToothMark size={20} />
            <span>AIDentalBook</span>
          </div>

          {children}

          <div className="auth-hipaa">
            <img
              src="/assets/hipaa-compliant.png"
              alt="HIPAA Compliant: AIDentalBook protects your health information under HIPAA"
              width="196"
              height="58"
              data-testid="hipaa-badge"
            />
          </div>

          <div className="auth-trust-sm">
            <p className="auth-trust-line">Your Data Stays Yours</p>
            <p className="auth-trust-line auth-trust-powered">Powered by Agape MedTecs Inc.</p>
          </div>
        </div>
      </div>
    </main>
  );
}

AuthLayout.propTypes = {children: PropTypes.node};
